module.exports = __webpack_public_path__ + "img/lte.feb6ea1e.png";